var _defs, _path, _path2, _circle, _circle2, _circle3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicIpAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "public-ip-address_svg__a",
    x1: 9,
    y1: 15.83,
    x2: 9,
    y2: 5.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bedd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#32caea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#32d2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32d4f5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 5.79h17v9.48a.57.57 0 01-.57.57H1.07a.57.57 0 01-.57-.57V5.79z",
    fill: "url(#public-ip-address_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07 2.17h15.86a.57.57 0 01.57.57v3.05H.5V2.73a.57.57 0 01.57-.56z",
    fill: "#767676"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.82,
    cy: 10.19,
    r: 1.38,
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.06,
    cy: 10.19,
    r: 1.38,
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.18,
    cy: 10.19,
    r: 1.38,
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.79,
    y: 3.25,
    width: 12.43,
    height: 1.46,
    rx: 0.28,
    fill: "#f2f2f2"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iYjkwZjc0ODUtZWRiOC00OWNjLTkxMTgtYmMwNTRjZjVjMThlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImFkNTJlMzFlLTc1ZGUtNDZhZi05YmRjLWJlYTAzOGFiNDIwOSIgeDE9IjkiIHkxPSIxNS44MyIgeDI9IjkiIHkyPSI1Ljc5IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMzJiZWRkIiAvPjxzdG9wIG9mZnNldD0iMC4xOCIgc3RvcC1jb2xvcj0iIzMyY2FlYSIgLz48c3RvcCBvZmZzZXQ9IjAuNDEiIHN0b3AtY29sb3I9IiMzMmQyZjIiIC8+PHN0b3Agb2Zmc2V0PSIwLjc4IiBzdG9wLWNvbG9yPSIjMzJkNGY1IiAvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjx0aXRsZT5JY29uLW5ldHdvcmtpbmctNjk8L3RpdGxlPjxwYXRoIGQ9Ik0uNSw1Ljc5aDE3YTAsMCwwLDAsMSwwLDB2OS40OGEuNTcuNTcsMCwwLDEtLjU3LjU3SDEuMDdhLjU3LjU3LDAsMCwxLS41Ny0uNTdWNS43OUEwLDAsMCwwLDEsLjUsNS43OVoiIGZpbGw9InVybCgjYWQ1MmUzMWUtNzVkZS00NmFmLTliZGMtYmVhMDM4YWI0MjA5KSIgLz48cGF0aCBkPSJNMS4wNywyLjE3SDE2LjkzYS41Ny41NywwLDAsMSwuNTcuNTdWNS43OWEwLDAsMCwwLDEsMCwwSC41YTAsMCwwLDAsMSwwLDBWMi43M0EuNTcuNTcsMCwwLDEsMS4wNywyLjE3WiIgZmlsbD0iIzc2NzY3NiIgLz48Y2lyY2xlIGN4PSIxMi44MiIgY3k9IjEwLjE5IiByPSIxLjM4IiBmaWxsPSIjZjJmMmYyIiAvPjxjaXJjbGUgY3g9IjkuMDYiIGN5PSIxMC4xOSIgcj0iMS4zOCIgZmlsbD0iI2YyZjJmMiIgLz48Y2lyY2xlIGN4PSI1LjE4IiBjeT0iMTAuMTkiIHI9IjEuMzgiIGZpbGw9IiNmMmYyZjIiIC8+PHJlY3QgeD0iMi43OSIgeT0iMy4yNSIgd2lkdGg9IjEyLjQzIiBoZWlnaHQ9IjEuNDYiIHJ4PSIwLjI4IiBmaWxsPSIjZjJmMmYyIiAvPjwvc3ZnPg==";
export { SvgPublicIpAddress as ReactComponent };